<template>
  <div>
    <v-sheet elevation="1">
      <v-toolbar dense color="white">
        <v-toolbar-title>{{ screenTitle }}</v-toolbar-title>
      </v-toolbar>
      <!-- 安定ヨウ素剤事前配布状況個人検索画面 (検索部分)-->
      <v-container fluid>
        <error-message :error-object="errorObject" />
        <success-message :success-object="successObject" />
        <p style="margin: 5px 0 15px 0">
          平時の安定ヨウ素剤の配布状況を確認します。
        </p>
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-select
              label="自治体"
              v-model="searchItem.municipCode"
              :placeholder="config.PLACEHOLDER_SELECT"
              :items="municipalities"
              clearable
              outlined
            >
            </v-select>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-text-field
              label="安定ヨウ素剤配布番号"
              v-model="searchItem.distNo"
              :placeholder="config.PLACEHOLDER_INPUT"
              clearable
              outlined
              counter="12"
              maxlength="12"
            >
            </v-text-field>
          </v-col>
          <v-col cols="6" md="3">
            <v-text-field
              label="氏名"
              v-model="searchItem.userName"
              :placeholder="config.PLACEHOLDER_NAME"
              clearable
              outlined
              counter="50"
              maxlength="50"
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="3">
            <v-text-field
              label="氏名カナ"
              v-model="searchItem.userNameKana"
              :placeholder="'例：ｶｺﾞｼﾏ ﾀﾛｳ'"
              clearable
              outlined
              counter="50"
              maxlength="50"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-select
              label="性別"
              v-model="searchItem.sex"
              :placeholder="config.PLACEHOLDER_SELECT"
              :items="sexes"
              item-value="value"
              item-text="text"
              return-object
              clearable
              outlined
            >
            </v-select>
          </v-col>
          <v-col cols="6" md="3">
            <v-text-field
              label="生年月日"
              v-model="searchItem.birthday"
              :placeholder="config.PLACEHOLDER_BIRTH"
              clearable
              outlined
              counter="10"
              maxlength="10"
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="3">
            <v-text-field
              label="薬剤配布日"
              v-model="searchItem.distributionDate"
              :placeholder="config.PLACEHOLDER_BIRTH"
              clearable
              outlined
              counter="10"
              maxlength="10"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-select
              label="薬剤種別"
              v-model="searchItem.distributionType"
              :placeholder="config.PLACEHOLDER_SELECT"
              :items="types"
              item-value="value"
              item-text="text"
              return-object
              clearable
              outlined
            >
            </v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="3">
            <v-text-field
              label="薬剤有効期限（開始）"
              v-model="stExpirationDate"
              :placeholder="config.PLACEHOLDER_SELECT_DATE"
              outlined
              clearable
              readonly
              @click:clear="searchItem.selectedStExpirationDate = null"
            >
              <template v-slot:append>
                <date-picker
                  v-model="searchItem.selectedStExpirationDate"
                  :max="searchItem.selectedEnExpirationDate"
                />
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="6" md="3">
            <v-text-field
              label="薬剤有効期限（終了）"
              v-model="enExpirationDate"
              :placeholder="config.PLACEHOLDER_SELECT_DATE"
              outlined
              clearable
              readonly
              @click:clear="searchItem.selectedEnExpirationDate = null"
            >
              <template v-slot:append>
                <date-picker
                  v-model="searchItem.selectedEnExpirationDate"
                  :min="searchItem.selectedStExpirationDate"
                />
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-select
              label="不配布理由"
              v-model="searchItem.reason"
              :placeholder="config.PLACEHOLDER_SELECT"
              :items="reasons"
              item-value="value"
              item-text="text"
              return-object
              clearable
              outlined
            >
            </v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn
              class="mx-2"
              color="primary"
              style="width: 130px"
              :disabled="validateSearch()"
              @click="showSearchDialog()"
            >
              検索
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
      <v-dialog v-model="searchDialog" persistent max-width="400">
        <v-card>
          <v-card-title></v-card-title>
          <v-card-text>
            <p>
              検索に時間を要する場合があります。<br />実行してよろしいですか？<br />※検索条件に期間を設定することを推奨します。
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="mx-2" color="primary" @click="search()">
              OK
            </v-btn>
            <v-btn class="mx-2" color="primary" @click="searchDialog = false">
              キャンセル
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-divider class="mb-1" />
      <!-- 安定ヨウ素剤事前配布状況個人検索画面 (一覧部分) -->
      <v-container fluid style="padding: 0">
        <p style="margin: 5px 0 15px 15px">合計</p>
        <v-data-table
          :headers="sumHeaders"
          :items="sumItems"
          locale="ja-jp"
          hide-default-footer
          disable-sort
        >
        </v-data-table>
        <p style="margin: 15px 0 15px 15px" v-if="lodine_table">一覧</p>
        <top-operation-data-table
          :headers="tableHeaders"
          :items="items"
          locale="ja-jp"
          ref="dist"
          style="white-space: nowrap;"
          class="table-nowrap"
          :sort-by="['no']"
          must-sort
          disp-mode="nowrap"
          v-if="lodine_table"
        >
          <template v-slot:top="{ pagination, options, updateOptions }">
            <v-data-footer
              :pagination="pagination"
              :options="options"
              :items-per-page-options="[5, 10, 15, -1]"
              @update:options="updateOptions"
              items-per-page-text="$vuetify.dataTable.itemsPerPageText"
            />
          </template>
          <template v-slot:[`item.municip_code`]="{ item }">
            <span>
              {{ municipalityName(item) }}
            </span>
          </template>
          <template v-slot:[`item.distribution_type_1`]="{ item }">
            <span>
              {{ distributionType1Text(item) }}
            </span>
          </template>
          <template v-slot:[`item.distribution_type_2`]="{ item }">
            <span>
              {{ distributionType2Text(item) }}
            </span>
          </template>
          <template v-slot:[`item.undistribution_reason`]="{ item }">
            <span>
              {{ reasonText(item) }}
            </span>
          </template>
        </top-operation-data-table>
      </v-container>
    </v-sheet>
    <v-overlay :value="overlay" opacity="1" color="white">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import Vue from "vue";
import DatePicker from "@/components/DatePicker";
import orderBy from "lodash/orderBy";
import config from "@/js/const";
import DateUtils from "@/plugins/date-utils";
import messageUtils from "@/mixins/message-utils";
import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import { AllAreaTranslator } from "@/js/translators/allAreaTranslator";
import { ScreenId } from "@/js/value-objects/screen-id";

const allAreaRepository = RepositoryFactory.get("allArea");
const lodinePreDistributionInfoRepository = RepositoryFactory.get("lodinePreDistributionInfo");

Vue.use(DateUtils);
export default {
  mixins: [messageUtils],
  components: {
    DatePicker,
    ErrorMessage: () => import("@/components/ErrorMessage"),
    SuccessMessage: () => import("@/components/SuccessMessage"),
    TopOperationDataTable: () => import("@/components/ui/TopOperationDataTable")
  },
  data: () => ({
    screenId: ScreenId.SF1002,
    overlay: false, // オーバーレイ表示用
    config: config,
    lodine_table: false,

    errFlag: false,
    //検索ダイアログ
    searchDialog: false,

    /**
     * 検索条件
     */
    searchItem: {
      municipCode: "", // 自治体
      distNo: "", // 安定ヨウ素剤配布番号
      userName: "", // 氏名
      userNameKana: "", // 氏名カナ
      sex: "", // 性別
      birthday: "", // 生年月日
      distributionDate: "", // 薬剤配布日
      distributionType: "", // 薬剤種別
      selectedStExpirationDate: "", // 薬剤有効期限（開始）
      selectedEnExpirationDate: "", // 薬剤有効期限（終了）
      reason: "" // 不配布理由
    },
    municipalities: [], // 自治体プルダウンの選択肢
    items: [], // データテーブル表示用
    /**
     * 合計
     */
    sumItems: [
      {
        two_pills: 0,
        one_pill: 0,
        jelly_agent_32: 0,
        jelly_agent_16: 0
      }
    ]
  }),

  computed: {
    screenTitle() {
      return ScreenId.getScreenTitle(this.screenId);
    },

    // 合計部のヘッダー項目
    sumHeaders() {
      return [
        {
          text: "丸剤2丸",
          value: "two_pills"
        },
        {
          text: "丸剤1丸",
          value: "one_pill"
        },
        {
          text: "ゼリー剤32.5mg",
          value: "jelly_agent_32"
        },
        {
          text: "ゼリー剤16.3mg",
          value: "jelly_agent_16"
        }
      ];
    },

    // 一覧部のヘッダー項目
    tableHeaders() {
      return [
        {
          text: "No",
          value: "no"
        },
        {
          text: "自治体",
          value: "municip_code"
        },
        {
          text: "安定ヨウ素剤配布番号",
          value: "lodine_tablets_dist_no"
        },
        {
          text: "氏名",
          value: "user_name"
        },
        {
          text: "氏名カナ",
          value: "user_name_kana"
        },
        {
          text: "性別",
          value: "sex"
        },
        {
          text: "生年月日",
          value: "birthday"
        },
        {
          text: "薬剤配布日",
          value: "distribution_date"
        },
        {
          text: "薬剤種別1",
          value: "distribution_type_1"
        },
        {
          text: "薬剤有効期限1",
          value: "expiration_date_1"
        },
        {
          text: "薬剤種別2",
          value: "distribution_type_2"
        },
        {
          text: "薬剤有効期限2",
          value: "expiration_date_2"
        },
        {
          text: "不配布理由",
          value: "undistribution_reason"
        },
        {
          text: "薬剤返却日",
          value: "return_date"
        }
      ];
    },

    // 薬剤有効期限（開始）
    stExpirationDate: {
      get: function() {
        return this.$dateUtils.toHyphenFromSlash(
          this.searchItem.selectedStExpirationDate
        );
      },
      set: function() {}
    },
    // 薬剤有効期限（終了）
    enExpirationDate: {
      get: function() {
        return this.$dateUtils.toHyphenFromSlash(
          this.searchItem.selectedEnExpirationDate
        );
      },
      set: function() {}
    },

    // 性別プルダウンの選択肢
    sexes() {
      return [
        {
          value: "男",
          text: "男"
        },
        {
          value: "女",
          text: "女"
        }
      ];
    },
    // 薬剤種別プルダウンの選択肢
    types() {
      return [
        {
          value: "1",
          text: "丸剤2丸"
        },
        {
          value: "2",
          text: "丸剤1丸"
        },
        {
          value: "3",
          text: "ゼリー剤32.5mg"
        },
        {
          value: "4",
          text: "ゼリー剤16.3mg"
        }
      ];
    },
    // 不配布理由プルダウンの選択肢
    reasons() {
      return [
        {
          value: "1",
          text: "辞退"
        },
        {
          value: "9",
          text: "その他"
        }
      ];
    }
  },

  watch: {
    $route: "initialize"
  },

  mounted() {
    this.pageTitle(this.screenTitle);
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      this.overlay = true;

      // 自治体情報取得
      await allAreaRepository
        .getAllArea()
        .then(response => {
          this.municipalities = AllAreaTranslator.toMunicipalities(response.data);
          const PREFECTURES = AllAreaTranslator.toPrefectures(response.data);
          PREFECTURES.forEach(data => {
            data.disp_no = Number(data.disp_no);
          });
          const SORTEDD_PREFECTURES = orderBy(PREFECTURES, ["disp_no"], ["desc"]);
          SORTEDD_PREFECTURES.forEach(prefecture => {
            this.municipalities.unshift(prefecture);
          });
        }).catch(e => {
          this.handleError(e, this.screenId, "aggregation-menu");
        });

      this.overlay = false;
    },

    showSearchDialog() {
      this.searchDialog = true;
    },

    /**
     * 検索バリデーションチェック処理
     */
    validateSearch() {
      // 自治体必須チェック
      if (!this.searchItem.municipCode) {
        return true;
      }
      return false;
    },

    // 検索処理
    async search() {
      this.overlay = true;
      this.loading = true;
      this.lodine_table = true;
      this.errFlag = false;
      await this.getLodineDistributionInfo();
      this.sumilate();
      this.overlay = false;
      this.loading = false;
      this.resetPage();
      this.searchDialog = false;
      this.goto();
    },

    // 最下部へスクロール
    goto() {
      let bodyHeight;
      if (this.errFlag) {
        bodyHeight = 0;
      } else {
        bodyHeight = document.body.clientHeight;
      }
      this.$vuetify.goTo(bodyHeight);
    },

    // 安定ヨウ素剤事前配布状況取得
    async getLodineDistributionInfo() {
      this.clearMessage();
      // 安定ヨウ素剤事前配布状況検索情報
      let payload = {};

      // 自治体
      if (this.searchItem.municipCode) {
        payload.municip_code = this.searchItem.municipCode;
      }

      // 安定ヨウ素剤配布番号
      if (this.searchItem.distNo) {
        payload.lodine_tablets_dist_no = this.searchItem.distNo;
      }

      // 氏名
      if (this.searchItem.userName) {
        payload.user_name = this.searchItem.userName;
      }

      // 氏名カナ
      if (this.searchItem.userNameKana) {
        payload.user_name_kana = this.searchItem.userNameKana;
      }

      // 性別
      if (this.searchItem.sex) {
        payload.sex = this.searchItem.sex.value;
      }

      // 生年月日
      if (this.searchItem.birthday) {
        payload.birthday = this.searchItem.birthday;
      }

      // 薬剤配布日
      if (this.searchItem.distributionDate) {
        payload.distribution_date = this.searchItem.distributionDate;
      }

      // 薬剤種別
      if (this.searchItem.distributionType) {
        payload.distribution_type = this.searchItem.distributionType.value;
      }

      // 薬剤有効期限（開始）
      if (this.searchItem.selectedStExpirationDate) {
        payload.expiration_date_from = this.$moment(
          this.searchItem.selectedStExpirationDate,
          config.DATETIME_FORMAT_YYYYMMDDHHMMSS_WITH_SLASH_COLON
        ).format(config.DATE_FORMAT_YYYYMMDD_WITH_SLASH);
      }

      // 薬剤有効期限（終了）
      if (this.searchItem.selectedEnExpirationDate) {
        payload.expiration_date_to = this.$moment(
          this.searchItem.selectedEnExpirationDate,
          config.DATETIME_FORMAT_YYYYMMDDHHMMSS_WITH_SLASH_COLON
        ).format(config.DATE_FORMAT_YYYYMMDD_WITH_SLASH);
      }

      // 不配布理由
      if (this.searchItem.reason) {
        payload.undistribution_reason = this.searchItem.reason.value;
      }

      await lodinePreDistributionInfoRepository
        .list(this.screenId, payload)
        .then(response => {
          let cnt = 1;
          response.data.results.forEach(data => {
            data["no"] = String(cnt);
            cnt++;
          });
          this.items = response.data.results;
        })
        .catch(e => {
          this.errFlag = true;
          this.handleCreateError(e);
        });
    },

    // 合計の計算
    sumilate() {
      this.sumItems = [];
      let sum_two_pills = 0;
      let sum_one_pill = 0;
      let sum_jelly_agent_32 = 0;
      let sum_jelly_agent_16 = 0;
      if (this.$refs.dist) {
        const filteredItems = this.$refs.dist.$children[0].$children[0].filteredItems;
        filteredItems.forEach(item => {
          switch (item.distribution_type_1) {
            case "1": // 丸剤2丸
              sum_two_pills++;
              break;
            case "2": // 丸剤1丸
              sum_one_pill++;
              break;
            case "3": // ゼリー剤32.5mg
              sum_jelly_agent_32++;
              break;
            case "4": // ゼリー剤16.3mg
              sum_jelly_agent_16++;
              break;
            default:
              break;
          }
          switch (item.distribution_type_2) {
            case "1": // 丸剤2丸
              sum_two_pills++;
              break;
            case "2": // 丸剤1丸
              sum_one_pill++;
              break;
            case "3": // ゼリー剤32.5mg
              sum_jelly_agent_32++;
              break;
            case "4": // ゼリー剤16.3mg
              sum_jelly_agent_16++;
              break;
            default:
              break;
          }
        });
      }
      const defaultItem = {
        two_pills: sum_two_pills,
        one_pill: sum_one_pill,
        jelly_agent_32: sum_jelly_agent_32,
        jelly_agent_16: sum_jelly_agent_16
      };
      this.sumItems.push(defaultItem);
    },

    // 自治体名取得
    municipalityName(item) {
      const data = this.municipalities.find(
        obj => obj.value === item.municip_code
      );
      if (data) {
        return data.text;
      }
      return "";
    },

    // 薬剤種別1取得
    distributionType1Text(item) {
      const data = this.types.find(
        obj => obj.value === item.distribution_type_1
      );
      if (data) {
        return data.text;
      }
      return "";
    },

    // 薬剤種別2取得
    distributionType2Text(item) {
      const data = this.types.find(
        obj => obj.value === item.distribution_type_2
      );
      if (data) {
        return data.text;
      }
      return "";
    },

    // 不配布理由取得
    reasonText(item) {
      const data = this.reasons.find(
        obj => obj.value === item.undistribution_reason
      );
      if (data) {
        return data.text;
      }
      return "";
    },
    
    /**検索時にページネーションをリセット
     * 初期表示ではテーブルが生成されていないためデータテーブルのメソッドが
     * 呼び出せない。生成されていることを確認してから呼びだす。
     */
    resetPage() {
      if (this.$refs.dist) {
        this.$refs.dist.resetPage();
      }
    }
  }
};
</script>

<style scoped>
.table-item-nowrap {
  white-space: nowrap;
}
</style>
